//import { checkTokenExists, setToken } from '../helpers/auth';
import api from './api';
import localforage from "localforage";

export const SET_REMOVALS = 'SET_REMOVALS';

export const getRemovals = () => async dispatch => {
  if (window.navigator.onLine) {
    return window.axios.get(api.removals.index)
      .then(async (response) => {
        dispatch(setRemovals(response.data.removals));

        return Promise.resolve({ ...response.data });
      })
      .catch(error => {
        return Promise.reject(error)
      });
  } else {
    try {
      await localforage.setDriver(localforage.INDEXEDDB);
      const removals = await localforage.getItem('bs_removals');

      if (removals) {
        dispatch(setRemovals(removals));
      }

      return Promise.resolve({ ...removals });
    } catch (e) {
      return Promise.reject(e);
    }
  }
};

export const setRemovals = (removals) => ({
  type: SET_REMOVALS,
  removals
});